<!--
    Styles
-->

<style scoped>

    .marker {
        text-align: right;
        border-left: 3px solid;
        padding: 6px 8px;
        max-width: 120px;
        min-width: 80px;
    }
    .marker:hover {
        z-index: 1;
    }
    .marker.hover {
        background: var(--cl-orange);
        color: var(--cl-white);
        z-index: 1;
    }
    .marker.hover:before {
        background: var(--cl-orange);
    }

</style>



<!--
    Template
-->

<template>
    <div class="marker arrow-bottom" :style="{borderLeftColor: priceColor(building.averagePrice)}" :class="{hover: isHovered({building: building.id})}">
        <p class="t12 u-cut">{{ building.name }}.</p>
        <p class="t15 u-cut w7">{{ building.averagePrice | price }}円</p>
    </div>
</template>



<!--
    Scripts
-->

<script>

    import {mapGetters} from 'vuex'
    import {price} from '@/common/helpers/parse'

    export default {

        props: [
            'building',
        ],

        filters: {
            price
        },

        computed: {

            ...mapGetters('dashboard', [
                'priceColor',
                'isHovered'
            ])

        }

    }

</script>

